import { makeStyles } from 'tss-react/mui';

export const useTodaySessionsStyles = makeStyles()((theme) => ({
  paperContainer: {
    padding: theme.spacing(5, 2)
  },
  paperContent: {
    margin: '0 auto',
    maxWidth: '424px',
  },
  contentStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  list: {
    padding: 0,
    margin: 0,
    paddingLeft: theme.spacing(2),
    color: theme.palette.text.secondary
  },
  bookNewClientsButtonContainer: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: 'repeat(2, 1fr)',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  reviewScheduleButton: {
    '& svg': {
      marginTop: '-2px'
    }
  }
}));
